/** Isolated Vite environment read so service orchestration remains unit-testable. */
export const getWebPlacementBuilderApiUrl = (): string | undefined =>
  import.meta.env.VITE_BUILDER_API_URL;
